import React, { useState, useEffect, useCallback } from 'react';
import { Modal, Card, Row, Col, Accordion, FormGroup } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import { isEmpty, cloneDeep, set } from 'lodash';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as action from '../store/OprationalCP.action';
import BtnAdd from '../../../Components/Utility/FilterAction/BtnAdd';
import BtnDelete from '../../../Components/Utility/FilterAction/BtnDelete';
import RenderLabelOptions from '../../ProductCP/Modals/RenderLabelOptions';
import RenderOptionsItem from '../../ProductCP/Modals/RenderOptionsItem';
import CommonMultiSelect from '../../../Components/Utility/FilterAction/CommonMultiSelect';
import {
  customStylesForOCP,
  columTypeList,
  AttributeList,
  outComeList,
  YearsWithId,
  ColumnValues,
  months,
  manualTypeList,
  manualLabelColours,
  manualStatusColours,
  checkIsNumber,
} from '../../../Components/helper';
import Loader from '../../../Components/Utility/Loader/Loader';
import * as systemMasterAction from '../../SystemMasters/Store/SystemMasters.action';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import { toasterMsg } from '../../../Components/Toaster/Toaster';

function AddEditColumn({ isProductArchived, open, toggle, editData, parentData }) {
  const {
    SystemMastersDetails: { brandList, seasonList, category1List, category2List, pcTypeList, productStatusList, multipleCategory3, multipleCategory4 },
    oprationalCPDetails: { supplierList, cardColmnsData },
    UserDetails: { userInfo },
    Users: { logInRights },
  } = useSelector((reducer) => reducer);
  const loggedInUserId = userInfo?.userId;
  const { CheckActionPermission } = useComponent();
  const { t } = useTranslation('common');
  const { id } = useParams();
  const dispatch = useDispatch();

  const OperationalAddEditAccess = CheckActionPermission(logInRights, 'criticalPath', 'operational', 'addEdit');
  const OperationalDeleteAccess = CheckActionPermission(logInRights, 'criticalPath', 'operational', 'delete');

  const [modalState, setModalState] = useState({
    cards: [
      {
        name: '',
        attribute: null,
        nameCount: 0,
        hasError: false,
        isRequired: false,
        columnType: null,
        manualType: null,
        outcome: null,
        filterSwitch: false,
        colorSwitch: false,
        filterObj: {
          brand: [],
          season: [],
          year: [],
          category_1: [],
          category_2: [],
          category_3: [],
          category_4: [],
          product_Type: [],
          month: [],
          suppliers: [],
          status: [],
        },
        category3Options: [],
        category4Options: [],
        selectedCatagory1: [],
        selectedCatagory2: [],
        selectedCatagory3: [],
        selectedCatagory4: [],
        colourArray: [
          {
            colourValue: '',
            colourType: 'green',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'amber',
            startPercentage: '',
            endPercentage: '',
          },
          {
            colourValue: '',
            colourType: 'red',
            startPercentage: '',
            endPercentage: '',
          },
        ],
        options: [{ name: '' }],
        labelColoursOptions: manualLabelColours,
        status: null,
        statusColoursOptions: manualStatusColours,
        isStatusEditTrue: false,
        characterLimit: '',
      },
    ],
    currentCardIndex: -1,
    dyanmicColumns: [],
    columnValues: [],
    loading: false,
  });

  const manualRemoval = (ele) => {
    if (['Checkbox', 'Dropdown', 'Multi_select_Dropdown', 'Radio_button'].includes(ele?.manualType?.key)) {
      delete ele?.labelColoursOptions;
      delete ele?.statusColoursOptions;
      delete ele?.isStatusEditTrue;
      delete ele?.colourCoding;
      delete ele?.status;
      delete ele?.characterLimit;
    } else if (ele?.manualType?.key === 'Label') {
      delete ele?.options;
      delete ele?.colourCoding;
      delete ele?.statusColoursOptions;
      delete ele?.isStatusEditTrue;
      delete ele?.status;
      delete ele?.characterLimit;
    } else if (ele?.manualType?.key === 'Status') {
      ele.status = ele?.statusColoursOptions.find((colSt) => colSt?.colourHexCode === ele?.status?.colourHexCode);
      delete ele?.options;
      delete ele?.colourCoding;
      delete ele?.labelColoursOptions;
      delete ele?.isStatusEditTrue;
      delete ele?.characterLimit;
    } else if (ele?.manualType?.key === 'Textbox') {
      delete ele?.status;
      delete ele?.options;
      delete ele?.colourCoding;
      delete ele?.labelColoursOptions;
      delete ele?.isStatusEditTrue;
      delete ele?.statusColoursOptions;
    } else {
      delete ele?.options;
      delete ele?.labelColoursOptions;
      delete ele?.statusColoursOptions;
      delete ele?.isStatusEditTrue;
      delete ele?.status;
      delete ele?.characterLimit;
    }
  };

  const sequenceChanger = (ele, i) => {
    return parentData?.Columns.findIndex((e) => e?._id === ele?._id) !== -1
      ? parentData?.Columns.findIndex((e) => e?._id === ele?._id)
      : parentData?.Columns.length + i;
  };

  const addUpdateColumn = async (cards) => {
    const updatedarr = [...cards];
    const hasNonUniqueNames = updatedarr.some((item, index) => updatedarr.filter((el, i) => el.name === item.name && index !== i).length > 0);
    if (hasNonUniqueNames) {
      toasterMsg('Please add unique column Names', 'danger');
    } else {
      const updatedArray = updatedarr.map((ele, i) => {
        delete ele?.hasError;
        delete ele?.nameCount;
        ele.operationalCPId = id;
        ele.source = {
          attribute: { name: ele?.attribute?.name, value: ele?.attribute?._id },
          outcome: { name: ele?.outcome?.name, value: ele?.outcome?._id },
        };
        ele.columnType = ele.columnType._id;
        delete ele.attribute;
        delete ele.outcome;
        ele.isColourCodingActive = ele.colorSwitch;
        ele.colourCoding = ele.colourArray;
        ele.isFilterActive = ele.filterSwitch;
        ele.filterData = ele.filterObj;
        delete ele.filterObj;
        delete ele.colourArray;
        delete ele.filterSwitch;
        delete ele.colorSwitch;
        if (ele.columnType === 'manual') {
          manualRemoval(ele);
          delete ele.filterData;
          delete ele.isFilterActive;
          delete ele.source;
          !ele?.isColourCodingActive && delete ele.colourCoding;
        }

        if (ele.columnType === 'source') {
          delete ele?.status;
          delete ele?.characterLimit;
          delete ele?.labelColoursOptions;
          delete ele?.options;
          delete ele?.statusColoursOptions;
        }
        delete ele?.category3Options;
        delete ele?.category4Options;
        delete ele?.selectedCatagory1;
        delete ele?.selectedCatagory2;
        delete ele?.selectedCatagory3;
        delete ele?.selectedCatagory4;
        ele.sequence = ele.sequence ? ele?.sequence : sequenceChanger(ele, i);
        return ele;
      });

      const insertObj = {
        columns: [...updatedArray],
        operationalCPId: id,
      };
      if (cards?.[0]?._id) {
        insertObj._id = cards?.[0]?._id;
      }
      // columns addUpdateApi
      const res = await dispatch(action.addColumnsToCard(insertObj, t));
      if (res) {
        await dispatch(action.getColumnsForCard(id));
        toggle();
      }
    }
    return true;
  };

  const filteredList = (ele) => {
    let finalList = [];
    if (ele?.attribute?._id === 'all_item') {
      finalList = outComeList.filter((e) => e?._id === 'percentage_of_approval' || e?._id === 'percentage_of_delivered');
    } else if (ele?.attribute?._id === 'mark_as_complete') {
      finalList = outComeList.filter((e) => e?._id === 'completion_percentage');
    } else {
      finalList = outComeList.filter((e) => e?._id === 'date_added' || e?._id === 'percentage_of_date_added');
    }
    return finalList;
  };

  useEffect(() => {
    if (editData && parentData) {
      const cards = [
        {
          ...editData,
          name: editData?.name,
          attribute: {
            name: editData?.source?.attribute?.name,
            _id: editData?.source?.attribute?.value,
          },
          nameCount: editData?.name?.length,
          hasError: false,
          columnType: columTypeList?.find((element) => element?._id === editData?.columnType),
          manualType: editData?.manualType,
          options: editData?.options || [{ name: '' }],
          labelColoursOptions: editData?.labelColoursOptions || manualLabelColours,
          status: editData?.status || null,
          statusColoursOptions: editData?.statusColoursOptions || manualStatusColours,
          characterLimit: editData?.characterLimit || '',
          outcome: {
            name: editData?.source?.outcome?.name,
            _id: editData?.source?.outcome?.value,
          },
          filterSwitch: editData?.isFilterActive,
          colorSwitch: editData?.isColourCodingActive,
          filterObj: {
            ...(editData?.filterData
              ? editData?.filterData
              : {
                  brand: [...parentData.brand],
                  season: [...parentData.season],
                  suppliers: [...parentData.suppliers],
                  year: [...(parentData?.year?.map((e) => parseInt(e)) || [])],
                  month: [...parentData.month],
                  product_Type: [...parentData.product_Type],
                  category_1: [...parentData.category_1],
                  category_2: [...parentData.category_2],
                  category_3: [...parentData.category_3],
                  category_4: [...parentData.category_4],
                  status: [...parentData.status],
                }),
          },
          colourArray: isEmpty(editData?.colourCoding)
            ? [
                {
                  colourValue: '',
                  colourType: 'green',
                  startPercentage: '',
                  endPercentage: '',
                },
                {
                  colourValue: '',
                  colourType: 'amber',
                  startPercentage: '',
                  endPercentage: '',
                },
                {
                  colourValue: '',
                  colourType: 'red',
                  startPercentage: '',
                  endPercentage: '',
                },
              ]
            : [...(editData?.colourCoding || [])],
          selectedCatagory1: editData?.filterData?.category_1,
          selectedCatagory2: editData?.filterData?.category_2,
        },
      ];
      setModalState((previousData) => ({
        ...previousData,
        cards: [...cards],
        currentCardIndex: 0,
      }));
    }
    if (editData?.filterData) {
      if (!isEmpty(editData?.filterData?.category_1) && !isEmpty(editData?.filterData?.category_2)) {
        const category3Call = async () => {
          const cat3params = {
            categoryOneId: editData?.filterData?.category_1,
            categoryTwoId: editData?.filterData?.category_2,
            categoryType: 3,
            loggedInUserId,
            isActive: true,
          };
          await dispatch(systemMasterAction.getMultipleCatgory(cat3params, false));
        };
        category3Call();
      }
      if (!isEmpty(editData?.filterData?.category_1) && !isEmpty(editData?.filterData?.category_2) && !isEmpty(editData?.filterData?.category_3)) {
        const category4Call = async () => {
          const cat4params = {
            categoryOneId: editData?.filterData?.category_1,
            categoryTwoId: editData?.filterData?.category_2,
            categoryThreeId: editData?.filterData?.category_3,
            categoryType: 4,
            loggedInUserId,
            isActive: true,
          };
          await dispatch(systemMasterAction.getMultipleCatgory(cat4params));
        };
        category4Call();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editData, parentData]);

  useEffect(() => {
    if (!isEmpty(cardColmnsData)) {
      setModalState((previousData) => ({
        ...previousData,
        dyanmicColumns: cardColmnsData?.filter((ele) => ele?._id !== editData?._id && ele?.columnType === 'manual' && ele?.manualType?.key === 'Date_picker'),
      }));
    }
  }, [cardColmnsData]);

  const addCard = () => {
    const updatedCardArray = [...modalState.cards];
    updatedCardArray.push({
      name: '',
      attribute: null,
      nameCount: 0,
      hasError: false,
      columnType: null,
      outcome: null,
      filterSwitch: false,
      colorSwitch: false,
      filterObj: {
        brand: [],
        season: [],
        year: [],
        category_1: [],
        category_2: [],
        category_3: [],
        category_4: [],
        product_Type: [],
        month: [],
        suppliers: [],
        status: [],
      },
      colourArray: [
        {
          colourValue: '',
          colourType: 'green',
          startPercentage: '',
          endPercentage: '',
        },
        {
          colourValue: '',
          colourType: 'amber',
          startPercentage: '',
          endPercentage: '',
        },
        {
          colourValue: '',
          colourType: 'red',
          startPercentage: '',
          endPercentage: '',
        },
      ],
      options: [{ name: '' }],
      labelColoursOptions: manualLabelColours,
      status: null,
      statusColoursOptions: manualStatusColours,
      isStatusEditTrue: false,
      characterLimit: '',
    });
    setModalState((oldState) => ({ ...oldState, cards: updatedCardArray }));
  };

  const deleteCard = (index) => {
    const updatedCards = [...modalState.cards];
    updatedCards.splice(index, 1);
    setModalState((oldState) => ({ ...oldState, cards: updatedCards }));
  };

  const fromifSection = (element, newCards, i) => {
    if (element === 'filters') {
      newCards[i].filterSwitch = false;
      newCards[i].filterObj = {
        brand: [],
        season: [],
        year: [],
        category_1: [],
        category_2: [],
        category_3: [],
        category_4: [],
        product_Type: [],
        month: [],
        suppliers: [],
        status: [],
      };
    } else {
      newCards[i].colorSwitch = false;
      newCards[i].colourArray = [
        {
          colourValue: '',
          colourType: 'green',
          startPercentage: '',
          endPercentage: '',
        },
        {
          colourValue: '',
          colourType: 'amber',
          startPercentage: '',
          endPercentage: '',
        },
        {
          colourValue: '',
          colourType: 'red',
          startPercentage: '',
          endPercentage: '',
        },
      ];
    }
  };

  const forNoSource = (newCards, i) => {
    if (newCards[i].source && !isEmpty(newCards[i].source)) {
      newCards[i].attribute = {
        name: newCards[i].source?.attribute?.name,
        _id: newCards[i].source?.attribute?.value,
      };
      newCards[i].outcome = {
        name: newCards[i].source?.outcome?.name,
        _id: newCards[i].source?.outcome?.value,
      };
    }
  };

  const nullingValue = (nullList, newCards, i) => {
    nullList?.forEach((element) => {
      if (['filters', 'colourCoading'].includes(element)) {
        fromifSection(element, newCards, i);
      } else {
        newCards[i][element] = null;
      }
    });
  };

  const onChange = (e, name, i, nullList) => {
    const newCards = [...modalState.cards];
    if (name === 'name') {
      newCards[i].name = e;
      newCards[i].nameCount = e?.length;
      forNoSource(newCards, i);
    } else if (['required', 'optional'].includes(name)) {
      newCards[i].isRequired = e && name === 'required' ? e : !e;
    } else {
      nullingValue(nullList, newCards, i);
      newCards[i][name] = e;
      if (name === 'attribute' && e?._id === 'all_item') {
        newCards[i].outcome = outComeList.find((e) => e?._id === 'percentage_of_approval');
      } else if (name === 'attribute' && e?._id === 'mark_as_complete') {
        newCards[i].outcome = outComeList.find((e) => e?._id === 'completion_percentage');
      }
    }
    newCards[i].hasError = false;
    setModalState((oldState) => ({ ...oldState, cards: newCards }));
  };

  useEffect(() => {
    if (modalState.currentCardIndex !== -1) {
      const cardsArray = [...modalState.cards];
      cardsArray[modalState.currentCardIndex].category3Options = [...multipleCategory3];
      cardsArray[modalState.currentCardIndex].category4Options = [...multipleCategory4];
      setModalState((otherState) => ({
        ...otherState,
        cards: [...cardsArray],
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [multipleCategory3, multipleCategory4, modalState.currentCardIndex]);

  const onChangeDropDown = async (e, name, index, i) => {
    const cardsArray = [...modalState.cards];
    switch (name) {
      case 'Brand':
        cardsArray[index].filterObj.brand = [...e];
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
        }));
        break;
      case 'Season':
        cardsArray[index].filterObj.season = [...e];
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
        }));
        break;
      case 'Year':
        cardsArray[index].filterObj.year = [...e];
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
        }));
        break;
      case 'Category 1':
        cardsArray[index].filterObj.category_1 = [...e];
        cardsArray[index].filterObj.category_3 = [];
        cardsArray[index].filterObj.category_4 = [];
        cardsArray[index].selectedCatagory1 = e;
        cardsArray[index].selectedCatagory3 = [];
        cardsArray[index].selectedCatagory4 = [];
        if (!isEmpty(e) && !isEmpty(cardsArray[index].selectedCatagory2)) {
          const cat3params = {
            categoryOneId: e,
            categoryTwoId: cardsArray[index].selectedCatagory2,
            categoryType: 3,
            loggedInUserId,
            isActive: true,
          };
          dispatch(systemMasterAction.clearMultipleReducer(['cat_3', 'cat_4']));
          dispatch(systemMasterAction.getMultipleCatgory(cat3params, false));
        }

        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
          currentCardIndex: index,
        }));
        break;
      case 'Category 2':
        cardsArray[index].filterObj.category_2 = [...e];
        cardsArray[index].filterObj.category_3 = [];
        cardsArray[index].filterObj.category_4 = [];
        cardsArray[index].selectedCatagory2 = e;
        cardsArray[index].selectedCatagory3 = [];
        cardsArray[index].selectedCatagory4 = [];
        if (!isEmpty(cardsArray[index].selectedCatagory1) && !isEmpty(e)) {
          const cat3params = {
            categoryOneId: cardsArray[index].selectedCatagory1,
            categoryTwoId: e,
            categoryType: 3,
            loggedInUserId,
            isActive: true,
          };
          dispatch(systemMasterAction.clearMultipleReducer(['cat_3', 'cat_4']));
          dispatch(systemMasterAction.getMultipleCatgory(cat3params, false));
        }
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
          currentCardIndex: index,
        }));
        break;
      case 'Category 3':
        cardsArray[index].filterObj.category_3 = [...e];
        cardsArray[index].filterObj.category_4 = [];
        cardsArray[index].selectedCatagory3 = e;
        cardsArray[index].selectedCatagory4 = [];
        if (!isEmpty(cardsArray[index].selectedCatagory1) && !isEmpty(cardsArray[index].selectedCatagory2) && !isEmpty(e)) {
          const callCategory4Api = async () => {
            const cat4params = {
              categoryOneId: cardsArray[index].selectedCatagory1,
              categoryTwoId: cardsArray[index].selectedCatagory2,
              categoryThreeId: e,
              categoryType: 4,
              loggedInUserId,
              isActive: true,
            };
            dispatch(systemMasterAction.clearMultipleReducer(['cat_4']));
            dispatch(systemMasterAction.getMultipleCatgory(cat4params));
          };
          callCategory4Api();
        }
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
          currentCardIndex: index,
        }));
        break;
      case 'Category 4':
        cardsArray[index].filterObj.category_4 = [...e];
        cardsArray[index].selectedCatagories4 = e;
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
          currentCardIndex: index,
        }));
        break;
      case 'Product Type':
        cardsArray[index].filterObj.product_Type = [...e];
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
        }));
        break;
      case 'Month':
        cardsArray[index].filterObj.month = [...e];
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
        }));
        break;
      case 'colourValue':
        cardsArray[index].colourArray[i].colourValue = e?._id;
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
        }));
        break;
      case 'Status':
        cardsArray[index].filterObj.status = [...e];
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
        }));
        break;

      default:
        cardsArray[index].filterObj.suppliers = [...e];
        setModalState((otherState) => ({
          ...otherState,
          cards: [...cardsArray],
        }));
        break;
    }
  };

  const handleManualChanges = (ele) => {
    const manualColumn = typeof ele?.columnType === 'object' ? ele?.columnType?._id === 'manual' : ele?.columnType === 'manual';

    return (
      (manualColumn && !ele.manualType?.key) ||
      (manualColumn && ele?.manualType?.key === 'Label' && !ele.labelColoursOptions.filter((e) => e.isLabelColourChecked).length > 0) ||
      (manualColumn && ele?.manualType?.key === 'Status' && (!ele?.status || !ele?.statusColoursOptions)) ||
      (manualColumn && ele?.manualType?.key === 'Textbox' && !ele?.characterLimit) ||
      (manualColumn &&
        ['Checkbox', 'Dropdown', 'Multi_select_Dropdown', 'Radio_button'].includes(ele?.manualType?.key) &&
        !ele.options?.[0]?.name?.trim().length > 0)
    );
  };

  const validatingIFCondition = (ele) => {
    const sourceColumn = typeof ele?.columnType === 'object' ? ele?.columnType?._id === 'source' : ele?.columnType === 'source';
    return (
      !ele?.name?.trim()?.length ||
      !ele?.columnType ||
      handleManualChanges(ele) ||
      (sourceColumn && !ele.attribute) ||
      (sourceColumn && !ele.outcome) ||
      (ele.colorSwitch &&
        !isEmpty(
          ele.colourArray.filter((element, index) => {
            return (
              // element.colourValue === "" ||
              element?.outcome?._id === 'date_added' || element?.manualType?.key === 'Date_picker'
                ? index === 1 && element?.colourValue && !element?.endPercentage
                : element?.colourValue === 'between' && !element?.startPercentage && !element?.endPercentage
            );
          }),
        ))
    );
  };

  const handleSubmit = async () => {
    const array = [...modalState.cards];
    const checkArray = array.filter((ele) => validatingIFCondition(ele));
    if (!checkArray || (checkArray && isEmpty(checkArray))) {
      setModalState((oldState) => ({ ...oldState, loading: true }));
      const res = await addUpdateColumn(array);
      res && setModalState((oldState) => ({ ...oldState, loading: false }));
    } else {
      const updatedArray = array.map((arrEle) => {
        if (validatingIFCondition(arrEle)) {
          arrEle.hasError = true;
        }
        return arrEle;
      });
      setModalState((oldState) => ({ ...oldState, cards: updatedArray }));
    }
  };

  const fromSectionSide = (cardEle, ele) => {
    return cardEle?.[ele] || cardEle?.source?.[ele];
  };

  const handleCancel = () => {
    toggle();
  };

  const forSwitch = (e, i) => {
    const cards = [...modalState.cards];
    if (e?.target?.name === 'filterSwitch') {
      cards[i].filterSwitch = e?.target?.checked;
      cards[i].filterObj = {
        brand: [],
        season: [],
        year: [],
        category_1: [],
        category_2: [],
        category_3: [],
        category_4: [],
        product_Type: [],
        month: [],
        suppliers: [],
        status: [],
      };
      setModalState((oldState) => ({
        ...oldState,
        cards: [...cards],
      }));
    } else {
      cards[i].colorSwitch = e?.target?.checked;
      cards[i].colourArray = [
        {
          colourValue: '',
          colourType: 'green',
          startPercentage: '',
          endPercentage: '',
        },
        {
          colourValue: '',
          colourType: 'amber',
          startPercentage: '',
          endPercentage: '',
        },
        {
          colourValue: '',
          colourType: 'red',
          startPercentage: '',
          endPercentage: '',
        },
      ];
      setModalState((oldState) => ({
        ...oldState,
        cards: [...cards],
      }));
    }
  };

  const changeColourInput = (value, name, index, i) => {
    const colourValues = [...modalState.cards];
    colourValues[index].colourArray[i][name] = value;
    setModalState((previousStates) => ({
      ...previousStates,
      colourValue: [...colourValues],
    }));
  };

  const constantTextValue = (i) => {
    if (i === 0) {
      return 'if within time frame of ';
    }
    if (i === 1) {
      return 'if exceeds time frame of ';
    }
    return 'if exceeds time frame of ';
  };

  const optionsArray = (array1, array2) => {
    return array1.filter((ele) => array2.includes(typeof ele === 'object' ? ele?._id : ele));
  };

  const filterComponent = (cardEle, cardIndex) => {
    const cat3Data = isEmpty(parentData?.category3List) ? cardEle?.category3Options : parentData?.category3List;
    const cat4Data = isEmpty(parentData?.category4List) ? cardEle.category4Options : parentData?.category4List;
    return (
      <Accordion className=" mb-3" key={`${cardEle?._id}_${cardIndex}`}>
        <Card className="rounded-0 flex-fill">
          <Card.Header className="bgcolor-dark rounded-0 py-1 px-2">
            <div className=" align-items-center p-2 reducing-switch-z-index">
              <div className="custom-control custom-switch">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id={`filterSwitch_${cardIndex}`}
                  name="filterSwitch"
                  onChange={(e) => forSwitch(e, cardIndex)}
                  checked={cardEle?.filterSwitch}
                />
                <label className="custom-control-label" htmlFor={`filterSwitch_${cardIndex}`}>
                  {t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.FILTERING')}
                </label>
              </div>
            </div>

            <span className="ml-auto">
              <span className={cardEle.filterSwitch ? 'icon-new-down-arrow-icon icon-inverse' : 'icon-new-down-arrow-icon'} />
            </span>
          </Card.Header>
          {cardEle.filterSwitch && (
            <Card.Body className="overflow-auto">
              <Row key={`filter_${cardEle?._id}_${cardIndex}`}>
                <Col lg={6} className="mb-3">
                  <CommonMultiSelect
                    label={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.BRAND')}
                    onChange={onChangeDropDown}
                    index={cardIndex}
                    selectedValue={cardEle?.filterObj?.brand}
                    optionList={!isEmpty(parentData?.brand) ? optionsArray(brandList, parentData?.brand) : brandList}
                    selectLabel="name"
                    selectValue="_id"
                  />
                </Col>
                <Col lg={6} className="mb-3">
                  <CommonMultiSelect
                    label={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.SEASON')}
                    onChange={onChangeDropDown}
                    index={cardIndex}
                    selectedValue={cardEle?.filterObj?.season}
                    optionList={!isEmpty(parentData?.season) ? optionsArray(seasonList, parentData?.season) : seasonList}
                    selectLabel="name"
                    selectValue="_id"
                  />
                </Col>
                <Col lg={6} className="mb-3">
                  <CommonMultiSelect
                    label={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.MONTH')}
                    onChange={onChangeDropDown}
                    index={cardIndex}
                    selectedValue={cardEle?.filterObj?.month}
                    optionList={!isEmpty(parentData?.month) ? optionsArray(months, parentData?.month) : months}
                    selectLabel="name"
                    selectValue="_id"
                  />
                </Col>
                <Col lg={6} className="mb-3">
                  <CommonMultiSelect
                    label={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.YEAR')}
                    onChange={onChangeDropDown}
                    index={cardIndex}
                    selectedValue={cardEle?.filterObj?.year}
                    optionList={isEmpty(parentData?.year) ? YearsWithId() : optionsArray(YearsWithId(), parentData?.year)}
                    selectLabel="name"
                    selectValue="_id"
                    scrollToCurrentYear
                  />
                </Col>
                <Col lg={6} className="mb-3">
                  <CommonMultiSelect
                    label={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.PRODUCT_TYPE')}
                    onChange={onChangeDropDown}
                    index={cardIndex}
                    selectedValue={cardEle?.filterObj?.product_Type}
                    optionList={!isEmpty(parentData?.product_Type) ? optionsArray(pcTypeList, parentData?.product_Type) : pcTypeList}
                    selectLabel="name"
                    selectValue="_id"
                  />
                </Col>
                <Col lg={6} className="mb-3">
                  <CommonMultiSelect
                    label={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.CATEGORY_1')}
                    onChange={onChangeDropDown}
                    index={cardIndex}
                    selectedValue={cardEle?.filterObj?.category_1}
                    optionList={!isEmpty(parentData?.category_1) ? optionsArray(category1List, parentData?.category_1) : category1List}
                    selectLabel="name"
                    selectValue="_id"
                  />
                </Col>
                <Col lg={6} className="mb-3">
                  <CommonMultiSelect
                    label={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.CATEGORY_2')}
                    onChange={onChangeDropDown}
                    index={cardIndex}
                    selectedValue={cardEle?.filterObj?.category_2}
                    optionList={!isEmpty(parentData?.category_2) ? optionsArray(category2List, parentData?.category_2) : category2List}
                    selectLabel="name"
                    selectValue="_id"
                  />
                </Col>
                <Col lg={6} className="mb-3">
                  <CommonMultiSelect
                    label={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.CATEGORY_3')}
                    onChange={onChangeDropDown}
                    index={cardIndex}
                    selectedValue={cardEle?.filterObj?.category_3}
                    optionList={
                      (!isEmpty(parentData?.category_3) && !isEmpty(parentData?.category3List)
                        ? optionsArray(parentData?.category3List, parentData?.category_3)
                        : cat3Data) || []
                    }
                    selectLabel="name"
                    selectValue="_id"
                  />
                </Col>
                <Col lg={6} className="mb-3">
                  <CommonMultiSelect
                    label={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.CATEGORY_4')}
                    onChange={onChangeDropDown}
                    index={cardIndex}
                    selectedValue={cardEle?.filterObj?.category_4}
                    optionList={
                      (!isEmpty(parentData?.category_4) && !isEmpty(parentData?.category4List)
                        ? optionsArray(parentData?.category4List, parentData?.category_4)
                        : cat4Data) || []
                    }
                    selectLabel="name"
                    selectValue="_id"
                  />
                </Col>

                <Col lg={6} className="mb-3">
                  <CommonMultiSelect
                    label={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.SUPPLIER')}
                    onChange={onChangeDropDown}
                    index={cardIndex}
                    selectedValue={cardEle?.filterObj?.suppliers}
                    optionList={isEmpty(parentData?.suppliers) ? supplierList : optionsArray(supplierList, parentData?.suppliers)}
                    selectLabel="name"
                    selectValue="_id"
                  />
                </Col>
                <Col lg={3} className="mb-3">
                  <CommonMultiSelect
                    label={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.STATUS')}
                    onChange={onChangeDropDown}
                    index={cardIndex}
                    selectedValue={cardEle?.filterObj?.status}
                    optionList={isEmpty(parentData?.status) ? productStatusList : optionsArray(productStatusList, parentData?.status)}
                    selectLabel="name"
                    selectValue="_id"
                  />
                </Col>
              </Row>
            </Card.Body>
          )}
        </Card>
      </Accordion>
    );
  };

  const chcekingValueExists = (ele, property, name) => {
    return typeof ele?.[property] === 'object' ? ele?.[property]?._id === name : ele?.[property] === name;
  };

  const chcekingFromDynamicArray = (array, value) => {
    return typeof value === 'object' ? array?.find((ele) => ele?._id === value?._id) : array?.find((ele) => ele?._id === value);
  };

  const chcekingFromDynamicArrayManual = (array, value) => {
    return typeof value === 'object' ? array?.find((ele) => ele?.key === value?.key) : array?.find((ele) => ele?.key === value);
  };

  const forIfSpan = (cardEle, index) => {
    return (cardEle?.outcome && cardEle?.outcome?._id === 'date_added') || cardEle?.manualType?.key === 'Date_picker' ? constantTextValue(index) : 'if ';
  };

  const forDateCondition = (cardEle) => {
    return (cardEle?.outcome && cardEle?.outcome?._id === 'date_added') || cardEle?.manualType?.key === 'Date_picker' || cardEle?.manualType?._id === 'date';
  };

  const colourDisable = (cEle) => {
    return [
      'Checkbox',
      'Dropdown',
      'HTML',
      'Multi_select_Dropdown',
      'Radio_button',
      'Label',
      'Text_area',
      'Number_Decimal',
      'Number_Integer',
      'Status',
      'Textbox',
      'Time_picker',
    ].includes(cEle?.manualType?.key);
  };

  const colourComponent = (cardEle, cardIndex) => {
    return (
      <Accordion key={`Column_${cardIndex}`}>
        <Card className="rounded-0 ">
          <Card.Header className="bgcolor-dark rounded-0 py-1 px-2">
            <div className="d-flex  align-items-center p-2 reducing-switch-z-index">
              <div className="custom-control custom-switch">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id={`colourSwitch_${cardIndex}`}
                  name="colourSwitch"
                  onChange={(e) => forSwitch(e, cardIndex)}
                  checked={cardEle.colorSwitch}
                  disabled={colourDisable(cardEle)}
                />
                <label className="custom-control-label" htmlFor={`colourSwitch_${cardIndex}`}>
                  {t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.COLOUR_CODING')}
                </label>
              </div>
            </div>
            <span className="ml-auto">
              <span className="icon-new-down-arrow-icon" />
            </span>
          </Card.Header>
          {cardEle.colorSwitch && (
            <Card.Body>
              <div className="flex-fill">
                {cardEle.colourArray.map((element, index) => {
                  return (
                    <div className="d-flex align-items-center f-14 mb-2" key={element?._id}>
                      <div className="status-color-container d-flex">
                        <span className={`${element?.colourType} rount-shape`} />
                      </div>
                      <div className="d-flex flex-wrap align-items-center">
                        <span className="px-2 text-nowrap">{forIfSpan(cardEle, index)}</span>
                        {forDateCondition(cardEle) ? (
                          <div className="w-180 px-2 my-1 my-md-0">
                            <Select
                              name="columnName"
                              options={modalState?.dyanmicColumns
                                ?.map((e) => ({ name: e?.name, _id: e?._id }))
                                ?.filter((element) => !cardEle?.colourArray?.map((e) => e?.colourValue)?.includes(element?._id))} // dynamic columns???
                              getOptionLabel={(option) => `${option.name}`}
                              getOptionValue={(option) => `${option._id}`}
                              maxMenuHeight={140}
                              menuPlacement="bottom"
                              menuPosition="fixed"
                              isClearable
                              menuShouldBlockScroll
                              menuShouldScrollIntoView
                              value={chcekingFromDynamicArray(modalState?.dyanmicColumns, element?.colourValue) || null}
                              styles={customStylesForOCP}
                              onChange={(e) => onChangeDropDown(e, 'colourValue', cardIndex, index)}
                              placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.SELECT_COLUMN')}
                            />
                          </div>
                        ) : (
                          <div className="w-180 px-2 my-1 my-md-0">
                            <Select
                              name="colourValue"
                              options={ColumnValues?.filter((ele) => !cardEle?.colourArray?.map((e) => e?.colourValue)?.includes(ele?._id))}
                              getOptionLabel={(option) => `${option.name}`}
                              getOptionValue={(option) => `${option._id}`}
                              menuPlacement="bottom"
                              menuPosition="fixed"
                              isClearable
                              menuShouldBlockScroll
                              menuShouldScrollIntoView
                              value={chcekingFromDynamicArray(ColumnValues, element?.colourValue) || null}
                              styles={customStylesForOCP}
                              maxMenuHeight={140}
                              onChange={(e) => onChangeDropDown(e, 'colourValue', cardIndex, index)}
                              placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.SELECT_VALUE')}
                            />
                          </div>
                        )}
                        {!forDateCondition(cardEle) && (
                          <>
                            <input
                              className="form-control text-bordered percentaage-input mx-2"
                              onChange={(e) => changeColourInput(e?.target?.value, 'startPercentage', cardIndex, index)}
                              disabled={!element?.colourValue}
                              value={element?.startPercentage}
                              name="colourStateValue"
                              type="number"
                            />{' '}
                            %{' '}
                          </>
                        )}
                        {(element?.colourValue === 'between' ||
                          (((cardEle?.outcome && cardEle?.outcome?._id === 'date_added') || cardEle?.manualType?.key === 'Date_picker') && index === 1)) && (
                          <div className="d-flex align-items-center ml-1">
                            {(cardEle?.outcome && cardEle?.outcome?._id === 'date_added') || (cardEle?.manualType?.key === 'Date_picker' && index === 1)
                              ? t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.BY')
                              : t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.AND')}{' '}
                            <input
                              className="form-control text-bordered percentaage-input mx-2"
                              onChange={(e) => changeColourInput(e?.target?.value, 'endPercentage', cardIndex, index)}
                              disabled={!element?.colourValue}
                              value={element?.endPercentage}
                              name="colourStateValue"
                              type="number"
                            />{' '}
                            {forDateCondition(cardEle) ? t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.DAYS') : '%'}
                            {cardEle?.hasError && element?.colourValue && !element?.endPercentage && (
                              <span className="error-message">
                                {t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.PLEASE_ENTER_VALUE')} {/* need to change after confirmation */}
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </Card.Body>
          )}
        </Card>
      </Accordion>
    );
  };

  const moveOption = (dragIndex, hoverIndex, cardEle, parentIndex) => {
    const currList = swapArrayLocs(cardEle?.options, dragIndex, hoverIndex);
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].options = currList;
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const addNewOptions = (parentIndex) => {
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].options.push({ name: '' });
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const handleOptionChange = (value, index, parentIndex) => {
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].options[index].name = value;
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  function swapArrayLocs(arr, index1, index2) {
    const temp = arr[index1];
    arr[index1] = arr[index2];
    arr[index2] = temp;
    return arr;
  }

  const removeOption = (index, parentIndex) => {
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].options.splice(index, 1);
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const renderOptionsList = useCallback(
    (option, optionIndex, cardEle, cardIndex) => {
      return (
        <RenderOptionsItem
          column={option}
          index={optionIndex}
          parentIndex={cardIndex}
          moveCard={moveOption}
          id={`${cardEle?._id}_${option?.Nmae}_${optionIndex}_${cardIndex}`}
          remove={removeOption}
          addNew={addNewOptions}
          handleChange={handleOptionChange}
          cardEle={cardEle}
          wholeArry={cardEle?.options}
        />
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [modalState?.cards],
  );

  const moveLabel = (dragIndex, hoverIndex, cardEle, parentIndex) => {
    const currList = swapArrayLocs(cardEle?.labelColoursOptions, dragIndex, hoverIndex);
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].labelColoursOptions = currList;
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const addNewlabels = (parentIndex) => {
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].labelColoursOptions.push({
      colourHexCode: '',
      colourName: '',
    });
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const handleLabelChange = (value, index, parentIndex, key) => {
    const copyState = cloneDeep(modalState?.cards);
    set(copyState, `[${parentIndex}].labelColoursOptions[${index}][${key}]`, value);
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const removelabel = (index, parentIndex) => {
    const copyState = cloneDeep(modalState?.cards);
    copyState[parentIndex].labelColoursOptions.splice(index, 1);
    setModalState((oldState) => ({
      ...oldState,
      cards: copyState,
    }));
  };

  const renderlabelList = useCallback(
    (label, labelIndex, cardEle, cardIndex) => {
      return (
        <RenderLabelOptions // label Item changes
          column={label}
          index={labelIndex}
          parentIndex={cardIndex}
          moveCard={moveLabel}
          id={`${cardEle?._id}_${label?.Nmae}_${labelIndex}_${cardIndex}`}
          removeLabel={removelabel}
          addNewLabel={addNewlabels}
          handleChange={handleLabelChange}
          cardEle={cardEle}
          wholeArry={cardEle?.labelColoursOptions}
        />
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [modalState?.cards],
  );

  const changeStatusArray = (e, cardIndex, keyIn, keyName) => {
    onChange(e.target.value, `statusColoursOptions[${keyIn}][${keyName}]`, cardIndex);
  };

  const manualOptions = (cardEle, cardIndex) => {
    return (
      chcekingValueExists(cardEle, 'columnType', 'manual') && (
        <>
          <Col lg={12} className="mb-3">
            <label className="asterisk-req f-14 mb-0">
              {t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.MANUAL_TYPE')} <span>*</span>
            </label>
            <Select
              name="manualType"
              options={manualTypeList}
              getOptionLabel={(option) => `${option.type}`}
              getOptionValue={(option) => `${option.key}`}
              value={chcekingFromDynamicArrayManual(manualTypeList, cardEle?.manualType) || null}
              maxMenuHeight={140}
              isDisabled={editData}
              menuPlacement="bottom"
              menuPosition="fixed"
              menuShouldBlockScroll
              menuShouldScrollIntoView
              styles={customStylesForOCP}
              onChange={(e) => onChange(e, 'manualType', cardIndex, ['outcome', 'attribute', 'filters', 'colourCoading'])}
              placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.SELECT_MANUAL_TYPE')}
            />
            {cardEle?.hasError && !fromSectionSide(cardEle, 'manualType') && <span className="error-message">Manual Type is required.</span>}
          </Col>
          {['Checkbox', 'Dropdown', 'Multi_select_Dropdown', 'Radio_button'].includes(cardEle?.manualType?.key) && (
            <DndProvider backend={HTML5Backend} key={`option_${cardEle?._id}_${cardEle?.name}_${cardIndex}`}>
              <Col lg={12} className="mb-3">
                <label className="asterisk-req f-14 mb-0">
                  {t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.MANUAL_TYPE_OPTIONS')} <span>*</span>
                </label>
                {cardEle?.options?.map((optionEle, optionIndex) => {
                  return renderOptionsList(optionEle, optionIndex, cardEle, cardIndex);
                })}
              </Col>
            </DndProvider>
          )}
          {cardEle?.manualType?.key === 'Label' && (
            <DndProvider backend={HTML5Backend} key={`label_${cardEle?._id}_${cardEle?.name}_${cardIndex}`}>
              <Col lg={12} className="mb-3">
                <label className="asterisk-req f-14 mb-0">
                  {t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.MANUAL_TYPE_LABELS')} <span>*</span>
                </label>
                {cardEle?.labelColoursOptions?.map((labelEle, labelIndex) => {
                  return renderlabelList(labelEle, labelIndex, cardEle, cardIndex);
                })}
                {cardEle.hasError && cardEle?.labelColoursOptions?.filter((e) => e?.isLabelColourChecked).length === 0 && (
                  <span className="error-message position-absolute "> {t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.PLEASE_SELECT_AT_LEAST_ONE_LABEL')}</span>
                )}
              </Col>
            </DndProvider>
          )}
          {cardEle?.manualType?.key === 'Status' && (
            <Col lg={{ span: 6, offset: 3 }} className="mb-3">
              <FormGroup className="m-0">
                <div className="input-group form-floating-label fixed-label">
                  <button
                    className="btn btn-default w-100 m-0 mb-2"
                    value={cardEle?.isStatusEditTrue}
                    onClick={() => onChange(!cardEle?.isStatusEditTrue, 'isStatusEditTrue', cardIndex)}
                  >
                    <span className="icon-edit mr-2" />
                    {t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.EDIT_COLOUR')}
                  </button>
                  {cardEle?.statusColoursOptions?.map((stat, keyIn) => {
                    return (
                      <>
                        <div
                          className="status-color-option"
                          onClick={() => onChange(stat, 'status', cardIndex)}
                          style={
                            cardEle?.status?.colourHexCode === stat?.colourHexCode
                              ? {
                                  border: '2px solid #8d8dff',
                                }
                              : {}
                          }
                        >
                          <div className="color-content">
                            <input
                              type="color"
                              className="form-control"
                              value={stat?.colourHexCode}
                              onChange={(e) => changeStatusArray(e, cardIndex, keyIn, 'colourHexCode')}
                              disabled={!cardEle?.isStatusEditTrue}
                            />
                          </div>
                          <input
                            type="text"
                            className="text-content f-14"
                            value={stat?.colourName}
                            placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.ADD_COLOUR_NAME')}
                            onChange={(e) => changeStatusArray(e, cardIndex, keyIn, 'colourName')}
                            readOnly={!cardEle?.isStatusEditTrue}
                          />
                        </div>
                        <br />
                      </>
                    );
                  })}
                </div>
              </FormGroup>
              {cardEle.hasError && !cardEle?.status && (
                <span className="error-message position-absolute">{t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.PLEASE_SELECT_STATUS')}</span>
              )}
            </Col>
          )}
          {cardEle?.manualType?.key === 'Textbox' && (
            <Col lg="12" className="mb-3">
              <FormGroup className="m-0">
                <div className="input-group form-floating-label fixed-label">
                  <input
                    type="text"
                    className="form-control f-14"
                    value={cardEle?.characterLimit}
                    placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.CHARACTER_LIMIT_PLACEHOLDER')}
                    onChange={(e) => {
                      if (checkIsNumber(e.target.value)) {
                        onChange(e.target.value, 'characterLimit', cardIndex);
                      }
                    }}
                  />
                  <label className="asterisk-req">{t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.CHARACTER_LIMIT')}</label>
                </div>
              </FormGroup>
              {cardEle.hasError && !cardEle?.characterLimit && (
                <span className="error-message position-absolute pb-3">{t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.CHARACTER_LIMIT_REQUIRED')}</span>
              )}
            </Col>
          )}
        </>
      )
    );
  };

  return (
    <Modal className="custom-modal ocp-modal" onHide={toggle} show={open}>
      <Modal.Header>{`${editData ? t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.EDIT') : t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.ADD')} ${
        editData ? 'Column' : 'New Columns'
      }`}</Modal.Header>
      {modalState?.loading ? (
        <Loader />
      ) : (
        <Modal.Body>
          {modalState.cards?.map((cardEle, cardIndex) => {
            return (
              <div className="d-flex" key={cardIndex}>
                <Card className="flex-fill rounded-0">
                  <Row className="px-3">
                    <Col lg={12} className="mb-3">
                      <div className="input-group form-floating-label-po fixed-label">
                        <div className="input-group form-floating-label fixed-label">
                          <input
                            type="text"
                            name="ColumnName"
                            placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.ENTER_COLUMN_NAME')}
                            value={cardEle?.name}
                            className="form-control f-14"
                            maxLength={30}
                            onChange={(e) => onChange(e?.target?.value, 'name', cardIndex)}
                          />
                          <label className="asterisk-req f-14 mb-0">
                            {t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.COLUMN_NAME')} <span>*</span>
                          </label>
                          <div className="text-count">{cardEle?.nameCount}/30</div>
                        </div>
                      </div>
                      {cardEle?.hasError && !cardEle?.name?.trim()?.length && (
                        <span className="error-message">{t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.COLUMN_NAME_REQUIRED')}</span>
                      )}
                    </Col>
                    <Col lg={12} className="mb-3">
                      <label className="asterisk-req f-14 mb-0">
                        {t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.COLUMN_TYPE')} <span>*</span>
                      </label>
                      <Select
                        name="columnType"
                        options={columTypeList}
                        getOptionLabel={(option) => `${option.name}`}
                        getOptionValue={(option) => `${option._id}`}
                        value={chcekingFromDynamicArray(columTypeList, cardEle?.columnType) || null}
                        menuPlacement="bottom"
                        menuPosition="fixed"
                        menuShouldBlockScroll
                        menuShouldScrollIntoView
                        styles={customStylesForOCP}
                        isDisabled={editData}
                        maxMenuHeight={140}
                        onChange={(e) => onChange(e, 'columnType', cardIndex, ['attribute', 'outcome', 'filters', 'colourCoading'])}
                        placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.SELECT_COLUMN_TYPE')}
                      />
                      {cardEle?.hasError && !cardEle?.columnType && (
                        <span className="error-message">{t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.COLOUM_TYPE_REQUIRED')}</span>
                      )}
                    </Col>
                    {chcekingValueExists(cardEle, 'columnType', 'source') && (
                      <>
                        <Col lg={12} className="mb-3">
                          <label className="asterisk-req f-14 mb-0">
                            {t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.ATTRIBUTE')} <span>*</span>
                          </label>
                          <Select
                            name="attribute"
                            options={AttributeList}
                            getOptionLabel={(option) => `${option.name}`}
                            getOptionValue={(option) => `${option._id}`}
                            value={chcekingFromDynamicArray(AttributeList, cardEle?.attribute) || null}
                            maxMenuHeight={140}
                            menuPlacement="bottom"
                            menuPosition="fixed"
                            menuShouldBlockScroll
                            menuShouldScrollIntoView
                            styles={customStylesForOCP}
                            onChange={(e) => onChange(e, 'attribute', cardIndex, ['outcome'])}
                            placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.SELECT_ATTRIBUTE')}
                          />
                          {cardEle?.hasError && !fromSectionSide(cardEle, 'attribute') && (
                            <span className="error-message">{t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.ATTRIBUTE_IS_REQUIRED')}</span>
                          )}
                        </Col>
                        {fromSectionSide(cardEle, 'attribute') && (
                          <Col lg={12} className="mb-3">
                            <label className="asterisk-req f-14 mb-0">
                              {t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.OUTCOME')} <span>*</span>
                            </label>
                            <Select
                              name="Outcome"
                              options={filteredList(cardEle)} // sectionList
                              getOptionLabel={(option) => `${option.name}`}
                              getOptionValue={(option) => `${option._id}`}
                              value={chcekingFromDynamicArray(filteredList(cardEle), cardEle?.outcome) || null}
                              maxMenuHeight={140}
                              styles={customStylesForOCP}
                              menuPlacement="bottom"
                              menuPosition="fixed"
                              menuShouldBlockScroll
                              menuShouldScrollIntoView
                              onChange={(e) => onChange(e, 'outcome', cardIndex)}
                              placeholder={t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.SELECT_OUTCOME')}
                            />
                            {cardEle?.hasError && !fromSectionSide(cardEle, 'outcome') && (
                              <span className="error-message">{t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.OUTCOME_IS_REQUIRED')}</span>
                            )}
                          </Col>
                        )}
                      </>
                    )}{' '}
                    {manualOptions(cardEle, cardIndex)}
                    <Col lg={12} className="mb-3">
                      <div className="d-flex align-items-center">
                        <p className="custom-radio">
                          <input
                            type="radio"
                            id={`optional_${cardIndex}`}
                            name={`optional_${cardIndex}`}
                            checked={!cardEle.isRequired}
                            onChange={(e) => onChange(e?.target?.checked, 'optional', cardIndex)}
                          />
                          <label htmlFor={`optional_${cardIndex}`}>{t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.OPTIONAL_FIELD')}</label>
                        </p>
                        <p className="custom-radio ml-4">
                          <input
                            type="radio"
                            id={`required_${cardIndex}`}
                            name={`required_${cardIndex}`}
                            checked={cardEle.isRequired}
                            onChange={(e) => onChange(e?.target?.checked, 'required', cardIndex)}
                          />
                          <label htmlFor={`required_${cardIndex}`}>{t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.REQUIRED_FIELD')}</label>
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <div className="collapse-card flex-fill px-3 mb-3">
                    {(typeof cardEle?.columnType === 'object' ? cardEle?.columnType?._id === 'source' : cardEle?.columnType === 'source') &&
                      filterComponent(cardEle, cardIndex)}
                    {cardEle?.columnType && colourComponent(cardEle, cardIndex)}
                  </div>
                </Card>
                {!editData && modalState.cards?.length - 1 === cardIndex && OperationalAddEditAccess && (
                  <div className="btn-outline-container">
                    <BtnAdd onBtnClick={addCard} addEditAccess />
                  </div>
                )}{' '}
                {modalState.cards?.length > 1 && OperationalDeleteAccess && (
                  <div className="btn-outline-container">
                    <BtnDelete multiDelete={() => deleteCard(cardIndex)} />
                  </div>
                )}
              </div>
            );
          })}
          <div className="modal-buttons mt-2 mt-md-5 d-flex justify-content-between">
            <button type="button" onClick={handleCancel} className="btn btn-default" disabled={isProductArchived}>
              {t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.CANCEL')}
            </button>
            {OperationalAddEditAccess && (
              <button type="button" onClick={handleSubmit} className="btn btn-default" disabled={isProductArchived}>
                {editData ? t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.UPDATE') : t('OPERATIONAL_CP.MODALS.ADD_EDIT_COLUMNS.ADD')}
              </button>
            )}
          </div>
        </Modal.Body>
      )}
    </Modal>
  );
}

export default AddEditColumn;
